import { useState } from "react";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { ValuesBar } from "@/components/ValuesBar";
import { ProductGrid } from "@/components/ProductGrid";
import { StoryPreview } from "@/components/StoryPreview";
import { FAQ } from "@/components/FAQ";
import { Footer } from "@/components/Footer";
import { NewsletterSignup } from "@/components/NewsletterSignup";
import { InstagramSection } from "@/components/InstagramSection";
import { TikTokSection } from "@/components/TikTokSection";
import { MissionSection } from "@/components/MissionSection";
import { DonationFeed } from "@/components/DonationFeed";
import GateIntro from "@/components/GateIntro";

const GATE_SESSION_KEY = "elfaza_gate_seen";

const Index = () => {
  const [showGate, setShowGate] = useState(() => {
    return !sessionStorage.getItem(GATE_SESSION_KEY);
  });

  const handleGateComplete = () => {
    sessionStorage.setItem(GATE_SESSION_KEY, "1");
    setShowGate(false);
  };

  return (
    <div className="min-h-screen flex flex-col relative">
      {showGate && <GateIntro onComplete={handleGateComplete} />}

      <Navbar />
      <Hero />
      <ValuesBar />

      {/* Products */}
      <main className="bg-gradient-cream bg-zellige">
        <div className="container mx-auto px-4 py-20 flex-1">
          <div id="products" className="text-center mb-14 scroll-mt-20">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary/10 border border-primary/20 text-primary text-sm font-body font-medium mb-5">
              ✦ Collection
            </div>
            <h2 className="text-3xl md:text-5xl font-display font-bold text-foreground mb-3">
              Nos Adhésifs
            </h2>
            <p className="text-muted-foreground font-body text-lg mt-2 max-w-lg mx-auto">
              Des adhésifs 3D en relief qui portent la fierté tunisienne 🇹🇳
            </p>
          </div>
          <ProductGrid />
        </div>
      </main>

      <div className="section-divider" />

      <MissionSection />

      <div className="section-divider" />

      <div id="donations" className="scroll-mt-20">
        <DonationFeed />
      </div>

      <div className="section-divider" />

      <InstagramSection />

      <div className="section-divider" />

      <TikTokSection />

      <div className="section-divider" />

      <StoryPreview />

      <div className="section-divider" />

      <div className="container mx-auto px-4 py-14" data-newsletter>
        <NewsletterSignup />
      </div>

      <FAQ />
      <Footer />
    </div>
  );
};

export default Index;
